import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Injector, Input, OnInit, Signal, WritableSignal, computed, inject, signal  } from '@angular/core';
import { CommonModule, CurrencyPipe, NgOptimizedImage, PercentPipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { LandingService } from '../services/landing.service';
import { catchError, map, Observable, of, switchMap, take, takeLast, tap, throwError } from 'rxjs';
import { EventInteractionService } from '@mare-common/ngx-mare-common';
import { MareLoaderService } from '@mare-common/ngx-mare-loader';
import { LandingInfo, LandingInterface, LandingKpiList } from './landing.model';
import { CommonConfig } from '../shared/common-config/common-config';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FooterStandaloneComponent } from '../layouts/standalone/footer/footer.component';
import { MediaMatcher } from '@angular/cdk/layout';
import { Platform } from '@angular/cdk/platform';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { JsonDataService } from '../services/json-data.service';
import { animate, keyframes, query, stagger, state, style, transition, trigger } from '@angular/animations';
import { ProductService, ProductsRequestParams } from '../services/product.service';
import { ButtonContactComponent, ProductContactInfo, UserContactInfo } from '../shared/button-contact/button-contact.component';
import { RoutingService } from '../services/routing.service';
import { environment } from 'src/environments/environment';
import { CartElement } from '../services/cart.service';
import { MareAuthService } from '@mare-common/ngx-mare-auth';
import { bounceInUp, pullFadeIn, pulse, pushFadeOut, slideInUp } from '../shared/animations/animations';



@Component({
  selector: 'app-landing',
  standalone: true,
  imports: [CommonModule,
    MatToolbarModule,
    NgOptimizedImage,
    FooterStandaloneComponent,
    MatCardModule,
    MatButtonModule,
   ButtonContactComponent
  ],
  providers: [
    CurrencyPipe,
    PercentPipe
  ],
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  animations: [
    pushFadeOut,
    pullFadeIn,
    slideInUp,
    pulse,
    trigger('pulsegrow', [
      state('inactive', style({ transform: 'scale(1)', })),
      state('active', style({ transform: 'scale(1)'})),
      transition('inactive => active', [
        animate('1000ms {{ delay }} ease-in-out',keyframes([
          style({ transform: 'scale(1)' ,offset: 0 }),
          style({ transform: 'scale(0.7)',offset: 0.4 }),
          style({ transform: 'scale(1.2)',offset: 0.6 }),
          style({ transform: 'scale(1)', offset: 1 }),
        ]))
      ])
    ]),
    
  ],
})
export class LandingComponent {
  // landingData = signal<LandingInterface | undefined>(undefined);
  test_token = 'clA1RyA2fs725yA8tUlgG8WmAMktopHuxpk13ukxzhwxYcmyeWiqlc2Cig273VlfGfxwgbSXMxO7DUJmsejQmyELBI1zszCB8AAsSVLl1JTAOu2f5wY3F3eH3qkVLbsi';
  token!: string;
  companyData$ = signal<LandingInfo | undefined>(undefined);
 
  landingData$ = signal<any | undefined >(undefined);
  landingMainProduct$ = signal(null);
  productContactInfo$ = signal<ProductContactInfo>({ name: '', id: '', sku: '' });
  userContactInfo$ = signal<UserContactInfo>({ name: '', email: '', phone: '', piva: '', productName: '', businessName: '' });
  responsiveClass$ = computed( () => this.isMobile$() ? 'ngx-assistance-set-form-mobile' : 'ngx-assistance-set-form-desktop' );
  isMobile$= signal<boolean>(false);
  mobileQuery: MediaQueryList;
  // private _mobileQueryListener: () => void;
  changeDetector: ChangeDetectorRef;

  flash = 'inactive';

  logoPath!: string ;
  kpiMap: any;
  showOffer$ = signal<boolean>(false);
  showDetails$ = signal<boolean>(false);
  state: string = 'inactive';
  stateDetails: string = 'inactive';
  ctaBuy:'Acquista'|'Attiva il servizio' = 'Acquista';

  kpiToShow!: {
    kpiName: string;
    value: number;
    kpiExceedMessage: string;
    kpiDescription: string;
    product: any;
    pid: string;
    sku: string;
    ctaBuy:string;
  };
  landingMainProduct: any;
  kpiUserInfo: any;
  piva!: string;
  constructor(
    private jsonDataService: JsonDataService,
    private loaderService: MareLoaderService,
    private route: ActivatedRoute, 
    private router: Router,
    private routingService: RoutingService,
    private landingService: LandingService,
    private mareAuthService: MareAuthService,
    private eventInteractionService: EventInteractionService,
    private commonConfig: CommonConfig,
    private media: MediaMatcher,
    private platform: Platform,
    private currencyPipe: CurrencyPipe,
    private productService: ProductService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    this.logoPath = this.commonConfig.getSiteLogo();
    this.mobileQuery = media.matchMedia('(max-width: ' + commonConfig.getMobileBreakpoint() + 'px)');
    this.isMobile$.set(this.platform.ANDROID || this.platform.IOS || this.mobileQuery.matches);
    this.changeDetector = changeDetectorRef;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile$.set(this.platform.ANDROID || this.platform.IOS || this.mobileQuery.matches);
    this.changeDetector.detectChanges();
  }
  ngOnInit() { 
    this.route.queryParams.subscribe(params => {
    this.loaderService.hideLoader();
      this.token = params['token'] ?? this.test_token;
      if (this.token) {
        this.getKpiMapJson().pipe(take(1)).subscribe((res: any) => {
          this.kpiMap = res;
        });
      this.getLandingData(this.token);
       
      } else {
        // qui manca il token o non è valido e dobbiamo gestire il redirect alla landing in home Delfi
        this.loaderService.hideLoader();
      }
    });
  }

  toggleStateFlash() {
    this.flash = this.flash === 'active' ? 'inactive' : 'active';
  }

  downloadReport() {
    this.landingService.downloadReport(this.piva).then((res: boolean | any) => {

      if(typeof res === 'boolean') {
        console.log('downloaded');
      } else {
        if(res.status == 'ok' && res.payload) {
          switch(res.payload) {
            case 'started':
              setTimeout(() => {
                this.downloadReport();
              }, 5000);
              break;
            case 'done':
            case 'completed':
              console.log('downloaded');
              break;
            case 'error':
              console.log('qualcosa è andato storto...');
                break;
            default:
              break;
          }
        }
      }
    }).catch((err: any) => {
      console.log(err);
    })
  }

  getLandingData(token: string) {
    this.landingService.getLanding(token).then((res: any) => {
      console.log('res', res);
      /** TODO
      *
      gestire risposta in errore 404 com messaggio o con contact form o con redirect in home delfi
      */
      if (res) {
        let mainKpi = this.mapMainKpi(res.kpiList[Object.keys(res.kpiList)[0] as any]);
          this.kpiUserInfo = res.info;
          let contactInfo: UserContactInfo = {
              name: res.info?.firstName + " " + res.info?.lastName,
              email: res.info.email,
              phone: res.info.phone,
            piva: res.info.piva,
            productName: mainKpi ? mainKpi.product.product_name : '',
            };
            this.userContactInfo$.set(contactInfo);
            this.piva = res.info.piva;
        if (mainKpi) {
          let productInfo:ProductContactInfo = {
            name: mainKpi.product.product_name,
            sku: mainKpi.sku,
            id: mainKpi.pid
          }
          this.productContactInfo$.set(productInfo);
          this.landingData$.set(mainKpi);
        }
        this.companyData$.set(res.info);
      }
    }).catch((err) => {
      console.error(err);
    });
  }

  mapMainKpi(kpiList: LandingKpiList) {
    let nameKpi = this.translateKpi(kpiList.kpis[0].kpi);
    let valueFormat = kpiList.kpis[0].abs_value ? 'currency' : (this.translateKpi(kpiList.kpis[0].kpi, 'format') ?? 'currency');

    let kpiValue: any = kpiList.kpis[0].abs_value ?? 0;
    // let kpiTypeMessage = valueFormat == 'currency' ? 'eccesso di' : ' eccesso del'
    let kpiTypeMessage = 'eccesso di';
    if (valueFormat) {
      switch (valueFormat) {
        case 'currency':
          kpiValue = this.currencyPipe.transform(Math.abs(kpiList.kpis[0].abs_value), 'EUR', 'symbol-narrow', '1.0-0');
          break;
        case 'percent':
          kpiValue = kpiValue + '%';
          break;
        default:
          kpiValue = kpiList.kpis[0].value;
          break;
      }
    }
    
    // let main_product = kpiList.products[Object.keys(kpiList.products)[0] as any] ? kpiList.products[Object.keys(kpiList.products)[0] as any] : null

    // TODO: se non c'è il main product?!?!?
    let main_product = null;
    if(kpiList.products) {
      main_product = Object.entries(kpiList.products).reduce((prev:any, current: any) => {
        return !prev || current[1].product_price > prev[1].product_price ? current : prev;
      }, undefined)[1];
      this.landingMainProduct = main_product;
    }
    
    this.kpiToShow = {
      kpiName: nameKpi,
      kpiExceedMessage: kpiTypeMessage,
      value: kpiValue,
      kpiDescription: this.translateKpi(kpiList.kpis[0].kpi, 'short_description'),
      product: main_product ??  'N/A',
      pid: main_product?.product_id ?? '0',
      sku: main_product?.product_sku ?? 'N/A',
      ctaBuy: main_product?.purchase_method && main_product.purchase_method.indexOf('contract') > -1 ? 'Attiva il servizio':'Acquista'
    };
    console.log(this.kpiToShow);
    return this.kpiToShow;
  }

  getKpiMapJson() {
    return this.jsonDataService.getJsonData('kpi_map.json');
  }

  translateKpi(kpi: any, key: 'title' | 'description' | 'short_description' |'format' = 'title') {
    if (!this.kpiMap) {
      this.getKpiMapJson().pipe(
        take(1)
      ).subscribe((res: any) => {
        this.kpiMap = res;
        return this.kpiMap[kpi][key];
      })
    } else {
      return this.kpiMap[kpi][key];
    }
  }

  goToOffer() {
    this.state = this.state === 'active' ? 'inactive' : 'active';
    setTimeout(() => {   
      this.showOffer$.set(true);
    },700)
  }

  goToDetails() {
    this.stateDetails = this.stateDetails === 'active' ? 'inactive' : 'active';
    this.showOffer$.set(false);
    setTimeout(() => {
      this.showDetails$.set(true);
    },700)
  }

  /**
   * Retrieves a product by its sku.
   * @param sku The sku of the product to retrieve.
   * @return A promise that resolves with the product object if found, or rejects with an error message if not found.
   */
  getProductBySku(sku: string) {
    let body: ProductsRequestParams = {
      skus: sku
    }
    return this.productService.getProductsParams(body,false,true);
  }
  /**
   * Retrieves a product by its id.
   * @param id The id of the product to retrieve.
   * @return A promise that resolves with the product object if found, or rejects with an error message if not found.
   */
  getProductById(id: string) {
    let body: ProductsRequestParams = {
      ids: id
    }
    return this.productService.getProductsParams(body,false,true);
  }

  /**
   * Redirects to the given platform page, either by opening a new tab (if the user is already logged in)
   * or by activating and logging in the user first (if the user is not logged in).
   * @param string The platform key to redirect to.
   */
  async goToPlatform(string: string) {
    let urlToTeridrect = this.routingService.checkRoute('/maresso?platform=' + string)
    if(!urlToTeridrect || !urlToTeridrect.url) {
      console.error('url not found');
      return
    }
    if(!this.mareAuthService.isLogged()) {
      await this.activateAndLogin(urlToTeridrect.url)
    } else {
      window.open(urlToTeridrect.url, '_blank');
    }
  }

  /**
   * Activates the user and logs him in, then redirects to the given url.
   * If the user is already activated, it only logs him in.
   * @param url The url to redirect to after activation/login.
   */
  async activateAndLogin(url: string) {
    if (!this.token)
    {
      console.error('token not found');
      return
    }
    let isToActivate = this.kpiUserInfo && this.kpiUserInfo.to_create_user ? this.kpiUserInfo.to_create_user : false;
    if (isToActivate) {
      await this.landingService.activateUser().catch((err: any) => {
        console.error(err);
      });
    } 
    this.router.navigate([environment.routingBasePath + '/login'], { queryParams: { delfi_token: this.token, redirect_uri:url  } });
  }

  /**
   * Logs in the user and then redirects to the cart with the given sku as param.
   * If the user is already logged in, it only redirects to the cart.
   * @param sku The sku of the product to add to the cart.
   */
 async loginAndBuy(sku: string) {
  // let url = window.location.origin.indexOf('localhost') > -1 ? 'https://servicecompany.maredigital.it'+ environment.routingBasePath+'/cart?sku=' + sku  : window.location.origin + environment.routingBasePath + '/cart?sku=' + sku
  let url = window.location.origin + '/' + environment.routingBasePath + '/cart?sku=' + sku
  if (!this.mareAuthService.isLogged()) {
      await this.activateAndLogin(url)
    } else {
      this.router.navigate([environment.routingBasePath + '/cart'], { queryParams: { sku: sku } });
    }
  }
 
  


      

}

